import http from '@root/utils/axios/admin';

let state = {
    CardCentersList: [],
    CardCenter: {
        data: {},
        error: {}
    }
}

let actions = {

    fetchCardCentersList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('/api/card-centers', { params: filter }).then((response) => {
                commit('setCardCenters', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    deleteCardCenter({ commit }, id) {
        return http.delete('/api/card-centers/' + id);
    },

    fetchCardCenter({ commit }, id) {
        return new Promise((resolve, reject) => {
            http.get('/api/card-centers/' + id).then((response) => {
                commit('setCardCenter', response.data.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    CreateCardCenter({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/api/card-centers', data).then((response) => {
                commit('setCardCenter', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setCardCenterError', error.response.data);
                }
                reject(error.response);
            })
        });

    },

    updateCardCenter({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/api/card-centers/' + data.get('id'), data).then((response) => {
                commit('setCardCenter', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setCardCenterError', error.response.data);
                }
                reject(error.response);
            })
        });
    },



}


let mutations = {
    setCardCenters(state, data) {
        state.CardCentersList = data;
    },
    setCardCenter(state, data) {
        state.CardCenter.data = data;
    },
    setCardCenterError(state, error) {

        state.CardCenter.error = error.errors;
    },
    cleanCardCenterError(state, error) {
        state.CardCenter.error = {};
    },

}

export default {
    state,
    actions,
    mutations
}